import { faProjectDiagram } from '@fortawesome/free-solid-svg-icons'
import { Box } from '@mui/material'
import { useEffect, useMemo } from 'react'

import { useAppContext } from '@/hooks'
import { useBranches } from '@/pages/User/pages/Branches/hooks/useBranches'
import { pickDefaultBranchId } from '@/pages/User/pages/Branches/pickDefaultBranch'

import { useSelectedBranch } from '../../TreePanelContext'
import { SelectionCard } from './SelectionCard'

export const BranchSelection = () => {
	const { t } = useAppContext()
	const { branches, hasSystemId, isLoading } = useBranches()
	const { selectedBranchId, setSelectedBranchId } = useSelectedBranch()

	const selectable = useMemo(
		() => branches.filter((branch) => branch.status !== 'DELETED'),
		[branches],
	)

	useEffect(() => {
		if (isLoading || !hasSystemId) return
		const nextId = pickDefaultBranchId(selectable, selectedBranchId)
		if (nextId && nextId !== selectedBranchId) {
			setSelectedBranchId(nextId)
		}
	}, [
		hasSystemId,
		isLoading,
		selectable,
		selectedBranchId,
		setSelectedBranchId,
	])

	const selected = selectable.find((branch) => branch.id === selectedBranchId)
	const options = selectable.map((branch) => ({
		id: branch.id,
		label: branch.name,
	}))

	return (
		<Box
			sx={{ display: 'flex', alignItems: 'center', width: '100%', height: 32 }}
			data-testid="branch-selection"
		>
			<SelectionCard
				compact
				icon={faProjectDiagram}
				iconBgColor="transparent"
				iconColor="#52666C"
				title={selected?.name || t('SYSTEM_SELECTION_NO_BRANCH')}
				options={options}
				selectedId={selectedBranchId ?? ''}
				onSelect={setSelectedBranchId}
				emptyLabel={t('SYSTEM_SELECTION_NO_BRANCH')}
				ariaLabel={t('SYSTEM_SELECTION_SELECT_BRANCH')}
				disabled={!hasSystemId}
				testIdPrefix="branch-selection"
			/>
		</Box>
	)
}
